import cn from 'classnames';
import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { httpGet } from '../../utils/httpClient';
import styles from './OffersList.module.scss';
import * as PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import { BCBreadcrumbs } from '../index';
import { Form, Formik } from 'formik';
import { RecommendationItem } from '../RecommendationsList/RecommendationItem/RecommendationItem';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import CloseIcon from '@mui/icons-material/Close';
import SortByAlphaIcon from '@mui/icons-material/SortByAlpha';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

import { useWindowWidth } from '@react-hook/window-size';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import qs from 'qs';
import { AirlineAutocomplete } from '../AirlineAutocomplete/AirlineAutocomplete';
import { Dialog, IconButton, TextField, ThemeProvider, Tooltip, createTheme, debounce } from '@material-ui/core';
import { usePrevious } from '../../utils/usePrevious';

const theme = createTheme({
  shape: {
    borderRadius: 12,
  },
  palette: {
    primary: {
      main: '#00454A',
    },
    dark: {
      main: '#0a0a0a',
    },
  },
  typography: {
    fontFamily: '"Libre Franklin", sans-serif',
  },
});


const getOfferPages = async (page, perPage, loadingHandler, filters = undefined) => {
  loadingHandler(true);
  let query = { ...filters };
  // if (filters && Object.keys(filters).length) {
  //   query = qs.stringify(filters);
  // }
  if (
    filters &&
    Object.keys(filters).length &&
    filters.sort &&
    Object.keys(filters.sort).length
  ) {
    if (filters.sort?.airline) {
      query.sort = `airline.name,${filters.sort?.airline}`;
    }

    if (!filters?.sort?.airline && !filters?.sort?.title) {
      query.sort = `offercount,desc`;
    }
  }

  if (!filters) {
    query.sort = `offercount,desc`;
  }


  const url = `/api/offer?page=${page}&size=${perPage}` + (Object.keys(query).length ? `&${qs.stringify(query)}` : '');

  return await (await httpGet(url, true)).json();
};

OffersList.propTypes = {
  country: PropTypes.string,
  heading: PropTypes.string,
};

export function OffersList() {
  const defaultFilters = {
    airline: '',
    title: '',
    sort: {
      airline: null,
      title: null,
      offercount: 'desc',
    },
  };
  const [currentPage, setCurrentPage] = useState(0);
  const [offers, setOffers] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState(defaultFilters);
  const [mobileFilters, setMobileFilters] = useState(false);
  const perPage = 10;
  const prevFilters = usePrevious({ filters });
  const width = useWindowWidth();

  useEffect(() => {
    const f = validateFilters(filters);
    getOfferPages(0, perPage, setLoading, f).then((res) => {
      setHasMore(!res.last);
      setOffers([...offers, ...res.content]);
      setLoading(false);    
    });
  }, []);

  const renderFilters = ({ setFieldValue, values }) => {
    return (
      <>
        <div className={styles.filterSmaller}>
          <AirlineAutocomplete
            name="airline"
            fullWidth
            value={values.airline}
            placeholder="Airline"
            primaryColor="#202020"
            setFieldValue={setFieldValue}
          />
        </div>

        <div className={styles.filterSmaller}>
          <TextField
            name="title"
            type="text"
            fullWidth
            value={values.title}
            placeholder="Search by title"
            onChange={(event) => {
              setFieldValue('title', event.target.value);
            }}
          />
        </div>
      </>
    );
  };

  const validateFilters = (f) => {
    const filters = cloneDeep(f);
    if (filters.sort?.airline === null) {
      delete filters.sort.airline;
    }
    if (!filters.airline) {
      delete filters.airline;
    }

    if (!filters.title) {
      delete filters.title;
    }
    if (filters.sort && !Object.keys(filters.sort).length) {
      delete filters.sort;
    }

    if (filters?.airline) {
      filters.airline = filters.airline.code;
    }
    return filters;
  };

  // useEffect(() => {
  //   if (JSON.stringify(defaultFilters) !== JSON.stringify(filters)) {
  //     const f = validateFilters(filters);
  //     getOfferPages(currentPage, perPage, setLoading, f).then((res) => {
  //       setHasMore(!res.last);
  //       setOffers([...offers, ...res.content]);
  //       setLoading(false);    
  //     });
  //   } else {
  //     getOfferPages(currentPage, perPage, setLoading).then((res) => {
  //       setHasMore(!res.last);
  //       setOffers([...offers, ...res.content]);
  //       setLoading(false);
  //     });
  //   }
  // }, [currentPage]);

  useEffect(() => {
    if (
      JSON.stringify(defaultFilters) !== JSON.stringify(filters) &&
      JSON.stringify(prevFilters.filters) !== JSON.stringify(filters) &&
      !filters.resetFilters
    ) {
      setLoading(true);
      const f = validateFilters(filters);
      getOfferPages(currentPage, perPage, setLoading, f).then((res) => {
        setHasMore(!res.last);
        setOffers([...res.content]);
        setLoading(false);
      });
    }
    if (filters.resetFilters) {
      setFilters(defaultFilters);
      setCurrentPage(0);
      setOffers([]);
      const f = validateFilters(defaultFilters);
      getOfferPages(0, perPage, setLoading, f).then((res) => {
        setHasMore(!res.last);
        setOffers([...res.content]);
        setLoading(false);
      });
    }
  }, [filters]);

  const handlePagination = (pageNumber) => {
    if (JSON.stringify(defaultFilters) !== JSON.stringify(filters)) {
      const f = validateFilters(filters);
      getOfferPages(pageNumber, perPage, setLoading, f).then((res) => {
        setHasMore(!res.last);
        setOffers([...offers, ...res.content]);
        setLoading(false);    
      });
    } else {
      getOfferPages(pageNumber, perPage, setLoading).then((res) => {
        setHasMore(!res.last);
        setOffers([...offers, ...res.content]);
        setLoading(false);
      });
    }
  };

  function getOfferItem(offerPage) {
    return {
      type: 'Offers',
      subtype: 'Offer',
      overline: 'Flight Offer',
      textId: offerPage.textId,
      image: offerPage.image?.substring(1),
      subtitle: offerPage.subtitle,
      title: offerPage.title,
      content: offerPage.content,
      tag: offerPage.offers ? ` ${offerPage.offers}  ${offerPage.offers === 1 ? 'offer' : 'offers'} available` : ' No offers available',
    };
  }

  return (
    <div>
      <div className={cn(styles.headingContainer)}>
        <BCBreadcrumbs className="text-white"
          headerText={'Offers'} />
        <h1 className={cn(styles.heading, 'font-fragment text-center')}>
            <div className={cn(styles.icon, 'm-auto text-white')}>
                <LocalOfferOutlinedIcon />
            </div>
            Best flight offers
        </h1>

        {width && (
          <ThemeProvider theme={theme}>
            <Formik
              enableReinitialize
              initialValues={filters}
              validate={debounce((value) => {
                setFilters({ ...value });
              }, 1000)}
            >
              {({ setFieldValue, values, resetForm }) => (
                <Form>
                  {width >= 1024 && (
                    <div className={styles.filtersContainer}>
                      {renderFilters({ setFieldValue, values })}

                      <Tooltip title="Sort alphabetically">
                        <IconButton
                          color="inherit"
                          type="reset"
                          onClick={() => {
                            if (filters.sort?.airline === 'desc') {
                              setCurrentPage(0);
                              setFieldValue('sort', {
                                ...filters.sort,
                                airline: 'asc',
                              });
                            }
                            if (filters.sort?.airline === 'asc') {
                              setCurrentPage(0);
                              setFieldValue('sort', {
                                ...filters.sort,
                                airline: null,
                              });
                            }
                            if (!filters.sort?.airline) {
                              setCurrentPage(0);
                              setFieldValue('sort', {
                                ...filters.sort,
                                airline: 'desc',
                              });
                            }
                          }}
                          aria-label="clear"
                          sx={{
                            border: '1px solid #fff',
                            borderRadius: '50%',
                            color: '#fff',
                            width: '56px',
                            marginRight: '1rem',
                          }}
                        >
                          <SortByAlphaIcon />
                          {filters.sort?.airline === 'asc' && (
                            <ArrowRightAltIcon
                              sx={{
                                position: 'absolute',
                                right: '-2px',
                                transform: 'rotate(90deg)',
                              }}
                            />
                          )}
                          {filters.sort?.airline === 'desc' && (
                            <ArrowRightAltIcon
                              sx={{
                                position: 'absolute',
                                right: '-2px',
                                transform: 'rotate(-90deg)',
                              }}
                            />
                          )}
                        </IconButton>
                      </Tooltip>
                      {JSON.stringify(defaultFilters) !==
                        JSON.stringify(filters) && (
                        <Tooltip title="Reset filters">
                          <IconButton
                            color="inherit"
                            type="reset"
                            onClick={() => {
                              resetForm({ values: defaultFilters });
                              setFilters({ resetFilters: true });
                            }}
                            aria-label="clear"
                            sx={{
                              border: '1px solid #fff',
                              borderRadius: '50%',
                              color: '#fff',
                              width: '56px',
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                    </div>
                  )}
                  {width < 1024 && (
                    <div className={styles.mobileFiltersWrapper}>
                      <div
                        className={styles.filtersButton}
                        onClick={() => setMobileFilters(true)}
                      >
                        <TuneRoundedIcon className={'mr-2'} /> Filters
                      </div>
                      <Dialog
                        open={mobileFilters}
                        fullWidth
                        PaperProps={{
                          style: {
                            margin: 0,
                            width: '100%',
                            bottom: 0,
                            position: 'absolute',
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0,
                          },
                        }}
                      >
                        <div className={styles.filtersContainerMobile}>
                          <IconButton
                            color="inherit"
                            onClick={() => setMobileFilters(false)}
                            aria-label="close"
                            className={styles.closeMobileFilters}
                          >
                            <CloseIcon />
                          </IconButton>
                          {renderFilters({ setFieldValue, values })}
                        </div>
                      </Dialog>

                      <div className={styles.sorting}>
                        <Tooltip title="Sort alphabetically">
                          <IconButton
                            color="inherit"
                            type="reset"
                            onClick={() => {
                              if (filters.sort?.airline === 'desc') {
                                setFieldValue('sort', {
                                  ...filters.sort,
                                  airline: 'asc',
                                });
                              }
                              if (filters.sort?.airline === 'asc') {
                                setFieldValue('sort', {
                                  ...filters.sort,
                                  airline: null,
                                });
                              }
                              if (!filters.sort?.airline) {
                                setFieldValue('sort', {
                                  ...filters.sort,
                                  airline: 'desc',
                                });
                              }
                            }}
                            aria-label="clear"
                            sx={{
                              border: '1px solid #fff',
                              borderRadius: '50%',
                              color: '#fff',
                              width: '42px',
                              marginRight: '1.25rem',
                            }}
                          >
                            <SortByAlphaIcon />
                            {filters.sort?.airline === 'asc' && (
                              <ArrowRightAltIcon
                                sx={{
                                  position: 'absolute',
                                  right: '-21px',
                                  transform: 'rotate(90deg)',
                                }}
                              />
                            )}
                            {filters.sort?.airline === 'desc' && (
                              <ArrowRightAltIcon
                                sx={{
                                  position: 'absolute',
                                  right: '-21px',
                                  transform: 'rotate(-90deg)',
                                }}
                              />
                            )}
                          </IconButton>
                        </Tooltip>
                        {JSON.stringify(defaultFilters) !==
                          JSON.stringify(filters) && (
                          <Tooltip title="Reset filters">
                            <IconButton
                              color="inherit"
                              type="reset"
                              onClick={() => {
                                resetForm({ values: defaultFilters });
                                setFilters({ resetFilters: true });
                              }}
                              aria-label="clear"
                              sx={{
                                border: '1px solid #fff',
                                borderRadius: '50%',
                                color: '#fff',
                                width: '42px',
                              }}
                            >
                              <CloseIcon />
                            </IconButton>
                          </Tooltip>
                        )}
                      </div>
                    </div>
                  )}
                </Form>
              )}
            </Formik>
          </ThemeProvider>
        )}
      </div>
      <div className={cn(styles.listContainer, 'container')}>
        <InfiniteScroll
          dataLength={offers.length}
          next={() => {
            setCurrentPage(currentPage + 1);
            handlePagination(currentPage + 1);
          }}
          hasMore={hasMore}
        >
         
          <div className={styles.list}>
            {offers.map((offer, index) => {
              return (
                <div key={index} className={styles.recommendationItem}>
                  <RecommendationItem item={getOfferItem(offer)} />
                </div>
              );
            })}
          </div>
        </InfiniteScroll>
        {loading && <div className={styles.loader} />}
        {!loading && offers.length === 0 && (
          <div className={styles.noResults}>No offers found</div>
        )}
      </div>
    </div>
  );
}
